export enum STORAGE_KEY {
  PROJECT_AI_SUMMARY = "saleslead-project-ai-summary",
  PORTFOLIO_AI_SUMMARY = "saleslead-portfolio-ai-summary",
  CUSTOMER_MODE_KEY = "saleslead-customer-mode",
  CALENDAR_SETTINGS = "saleslead-calendarSettings",
  CALENDAR_FILTERS = "saleslead-calendarFilters",
  LAST_APPLIED_TEMPLATE = "saleslead-lastAppliedTemplate",
}

export const setStorageItem = (key: STORAGE_KEY, value: string) =>
  window.localStorage.setItem(key, value);

export const getStorageItem = (key: STORAGE_KEY): string | null =>
  window.localStorage.getItem(key);

export const removeStorageItem = (key: STORAGE_KEY) =>
  window.localStorage.removeItem(key);
